import React from 'react';
import { CtaWrapper } from './CtaStyles';

const Cta = ({ children, onclick }) => {
    return (
        <CtaWrapper onClick={onclick}>
            {children}
        </CtaWrapper>
    )
}

export default Cta;